import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.TMH_API, // api 的 base_url
  timeout: 60000, // 请求超时时间
})


export default service


// WEBPACK FOOTER //
// ./src/config/tmhRequest.js